// A facility's SiteLink Location Code. Reads either the flattened item shape
// (`locationCode` hoisted onto the facility, as useDashboard produces) or the raw
// GraphQL shape, where it sits behind the ProfileUnion's FacilityProfile member.
export function facilityLocationCode(facility) {
  return facility?.locationCode || facility?.profile?.locationCode || null;
}

// A facility matches a query by name OR location code — case-insensitive substring,
// one input, no mode switch. Only SiteLink-integrated facilities carry a location
// code (sitelink_service is its sole writer), so matching the field is what scopes a
// code search to SiteLink facilities; the UI deliberately holds no PMS-specific logic.
export function matchesFacility(facility, queryText) {
  const query = (queryText || "").trim().toLowerCase();
  if (!query) return true;
  return [facility?.name, facilityLocationCode(facility)].some((value) =>
    (value || "").toLowerCase().includes(query)
  );
}
